import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

/**
 * Quando l'auto-exchange PKCE stabilisce una sessione di recovery (evento
 * `PASSWORD_RECOVERY`), porta l'utente alla pagina di reset password — anche
 * se il redirect è atterrato su un'altra rotta (es. la home, fallback Site URL
 * di Supabase quando il `redirect_to` non è in allowlist).
 *
 * Va montato dentro il `<BrowserRouter>` (AuthProvider è esterno al router,
 * quindi il listener di auth non può navigare da solo).
 */
export const useRecoveryRedirect = (): void => {
  const navigate = useNavigate();

  useEffect(() => {
    const { data } = supabase.auth.onAuthStateChange((event) => {
      if (
        event === "PASSWORD_RECOVERY" &&
        window.location.pathname !== "/reset-password"
      ) {
        navigate("/reset-password", { replace: true });
      }
    });

    return () => data.subscription.unsubscribe();
  }, [navigate]);
};
